import Box from '@mui/material/Box';
import React from 'react';

import { PriorityDotProps } from './PriorityDot.props';
import { COLORS } from '../../../configs/colors';

interface PriorityStyle {
  color: string;
  bg: string;
}

const getPriorityStyle = (priority: string): PriorityStyle => {
  const lower = priority.toLowerCase();

  if (lower === 'critical') return { color: COLORS.PriorityCritical, bg: COLORS.PriorityCriticalBg };
  if (lower === 'high') return { color: COLORS.PriorityHigh, bg: COLORS.PriorityHighBg };
  if (lower === 'medium') return { color: COLORS.PriorityMedium, bg: COLORS.PriorityMediumBg };
  if (lower === 'low') return { color: COLORS.PriorityLow, bg: COLORS.PriorityLowBg };

  return { color: COLORS.StatusDefaultText, bg: COLORS.StatusDefaultBg };
};

const capitalize = (str: string): string =>
  str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();

export const PriorityDot: React.FC<PriorityDotProps> = ({ priority, color: colorOverride }) => {
  const style = getPriorityStyle(priority);
  const textColor = colorOverride || style.color;

  return (
    <Box
      component="span"
      aria-label={`Priority: ${capitalize(priority)}`}
      sx={{
        display: 'inline-flex',
        alignItems: 'center',
        gap: 0.5,
        fontSize: '11px',
        fontWeight: 600,
        color: textColor,
        bgcolor: colorOverride ? `${colorOverride}18` : style.bg,
        px: 1,
        py: '2px',
        borderRadius: '4px',
        whiteSpace: 'nowrap',
      }}
    >
      {capitalize(priority)}
    </Box>
  );
};
